var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.99966H5.38427V13.9993L0 14.0003V6.99966ZM15.6157 21H18.5769C19.9127 21 21 19.9137 21 18.5769V15.6157H15.6157V21ZM18.5769 0H15.6157V5.38427H21V2.42308C21 1.08634 19.9127 0 18.5769 0ZM6.99966 21H13.9993V15.6157H6.99966V21ZM6.99966 14.0003H13.9993V7.00069H6.99966V14.0003ZM0 2.42308V5.38427H5.38427V0H2.42308C1.08735 0 0 1.08634 0 2.42308ZM0 18.5769C0 19.9137 1.08735 21 2.42308 21H5.38427V15.6157H0V18.5769ZM6.99966 5.38427H13.9993L14.0003 0H7.00067V5.38427H6.99966ZM15.6157 14.0003H21V7.00069H15.6157V14.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4081dfb674f97524c0cbe0985e48cb9f.svg";
export { ForwardRef as ReactComponent };